/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import ModalBodyLayout from '../shared/ModalBodyLayout';
import PgwIframe from '../../components/PgwIframe';
import { showAlert } from '../../utilities/notifications';
import { PGW_BUY_CRYPTO } from './mutations';
import { GenericLoading } from '../../components/Placeholders';
import { spendingFlowScreens } from './constants';

const PGWProceedWithPayment = ({ pgwRequest, openScreen }) => {
  const [pgwUrl, setPgwUrl] = useState();
  const { t: translate } = useTranslation();
  const [showPgwFooter, setShowPgwFooter] = useState(false);

  const { mutate: buyCryptoPGW, isLoading } = useMutation(PGW_BUY_CRYPTO, {
    onSettled: (data, error) => {
      if (error || (data && !data?.redirectUrl)) {
        showAlert({ message: error?.message || data, type: 'danger' });
      } else if (data && data.redirectUrl) {
        setPgwUrl(data.redirectUrl);
      }
    },
  });

  useEffect(() => {
    buyCryptoPGW({ ...pgwRequest?.params });
  }, [pgwRequest?.params]);

  const handleResolvePgw = (isConfirmed) => {
    if (!isConfirmed) {
      setShowPgwFooter(false);
    } else {
      setShowPgwFooter(true);
    }
  };

  const renderFooter = () => {
    if (pgwUrl && showPgwFooter) {
      return (
        <button
          type="button"
          className="btn btn-primary py-3"
          onClick={() => {
            openScreen(spendingFlowScreens.CALCULATOR);
          }}>
          {translate('continue_btn_title')}
        </button>
      );
    }
    return <></>;
  };

  return (
    <ModalBodyLayout
      title={translate('card_order_proceed_with_payment_title')}
      onPrevClick={() => openScreen(spendingFlowScreens.ADD_MORE_COLLATERAL)}
      renderHeader={() => {}}
      renderFooter={pgwUrl && showPgwFooter ? renderFooter : null}
      withBack>
      {isLoading ? (
        <GenericLoading />
      ) : (
        <PgwIframe pgwUrl={pgwUrl} onPgwResolve={handleResolvePgw} />
      )}
    </ModalBodyLayout>
  );
};

export default PGWProceedWithPayment;

PGWProceedWithPayment.propTypes = {
  openScreen: PropTypes.func.isRequired,
  pgwRequest: PropTypes.object.isRequired,
};
